import React from 'react';
import StaticPage, { Section } from './StaticPage';

export default function PrivacyPolicy() {
  return (
    <StaticPage title="Privacy Policy" subtitle="How RentalX collects, uses, and protects your personal information.">
      <p className="text-sm text-gray-500 mb-8">Last updated: February 2026</p>

      <Section title="Information We Collect">
        <p>We collect information you provide directly to us when you create an account, post listings, or contact us for support. This includes:</p>
        <ul className="list-disc list-inside space-y-1 mt-2">
          <li>Personal information: name, email address, phone number</li>
          <li>University or business details (for students and landlords respectively)</li>
          <li>Property information provided in listings</li>
          <li>Messages exchanged through our platform</li>
          <li>Usage data: pages visited, search queries, time on site (anonymised)</li>
          <li>Device and browser information for security purposes</li>
        </ul>
      </Section>

      <Section title="How We Use Your Information">
        <ul className="list-disc list-inside space-y-1">
          <li>To provide and improve our accommodation search services</li>
          <li>To verify user identity and prevent fraud</li>
          <li>To facilitate communication between students and landlords</li>
          <li>To send service notifications and updates (you can opt out at any time)</li>
          <li>To comply with Australian legal obligations</li>
          <li>To analyse platform usage and improve the user experience</li>
        </ul>
      </Section>

      <Section title="How We Share Your Information">
        <p>We do not sell your personal information to third parties. We may share information with:</p>
        <ul className="list-disc list-inside space-y-1 mt-2">
          <li>Other users as necessary for the service (e.g., your first name visible to landlords you contact)</li>
          <li>Service providers who help us operate the platform (e.g., cloud hosting, email delivery)</li>
          <li>Law enforcement when required by Australian law</li>
          <li>University partners, only with your explicit consent</li>
        </ul>
      </Section>

      <Section title="Data Security">
        <p>Your data is encrypted in transit (HTTPS) and at rest. We use industry-standard security practices including access controls, audit logs, and regular security reviews. We retain your data for as long as your account is active and for up to 3 years thereafter for legal compliance.</p>
      </Section>

      <Section title="Your Rights">
        <p>Under the Australian Privacy Act 1988, you have the right to:</p>
        <ul className="list-disc list-inside space-y-1 mt-2">
          <li>Access the personal information we hold about you</li>
          <li>Request correction of inaccurate information</li>
          <li>Request deletion of your account and data</li>
          <li>Opt out of marketing communications</li>
          <li>Lodge a complaint with the Office of the Australian Information Commissioner (OAIC)</li>
        </ul>
      </Section>

      <Section title="Cookies">
        <p>We use cookies to keep you logged in, remember your preferences, and understand how you use RentalX. See our <a href="/cookies" className="text-[#094f6f] underline">Cookie Policy</a> for full details.</p>
      </Section>

      <Section title="Contact">
        <p>Privacy enquiries: <strong>privacy@rentalx.com.au</strong><br />
        Office of the Australian Information Commissioner: <a href="https://www.oaic.gov.au" target="_blank" rel="noopener noreferrer" className="text-[#094f6f] underline">oaic.gov.au</a></p>
      </Section>
    </StaticPage>
  );
}
